/**
 * OhMy Collage:
 * 1) Sanfter Parallax beim Scrollen (nur wenn [data-ohmy-parallax], Desktop, keine reduzierte Bewegung)
 * 2) Klick-Zoom: Foto vergrößert sich animiert vom Polaroid zur Bildschirmmitte (FLIP-Animation)
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) Parallax ---------- */
  var collages = document.querySelectorAll('[data-ohmy-parallax]');
  if (collages.length && !reducedMotion && window.matchMedia('(min-width: 750px)').matches) {
    var ticking = false;

    var update = function () {
      ticking = false;
      var vh = window.innerHeight;
      collages.forEach(function (collage) {
        var rect = collage.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = ((rect.top + rect.height / 2) - vh / 2) / (vh / 2 + rect.height / 2);
        collage.querySelectorAll('.ohmy-collage__photo').forEach(function (photo) {
          var depth = parseFloat(photo.dataset.depth || '0.06');
          var shift = Math.round(progress * depth * -220);
          var rot = getComputedStyle(photo).getPropertyValue('--rot') || '0deg';
          photo.style.transform = 'translateY(' + shift + 'px) rotate(' + rot.trim() + ')';
        });
      });
    };

    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- 2) Klick-Zoom (Lightbox) ---------- */
  var openLightbox = null;

  function closeLightbox() {
    if (!openLightbox) return;
    var lb = openLightbox;
    openLightbox = null;
    var frame = lb.querySelector('.ohmy-lightbox__img');
    lb.classList.remove('is-open');
    var src = lb._sourceRect;
    frame.style.top = src.top + 'px';
    frame.style.left = src.left + 'px';
    frame.style.width = src.width + 'px';
    frame.style.height = src.height + 'px';
    frame.style.transform = 'rotate(' + lb._sourceRot + ')';
    setTimeout(function () { lb.remove(); }, 340);
  }

  document.addEventListener('click', function (e) {
    var photo = e.target.closest('.ohmy-collage__photo[data-zoom-src], .ohmy-collage__photo[data-zoom-video]');
    if (!photo) return;
    if (openLightbox) { closeLightbox(); return; }

    var rect = photo.getBoundingClientRect();
    var rot = getComputedStyle(photo).getPropertyValue('--rot').trim() || '0deg';
    var isVideo = photo.hasAttribute('data-zoom-video');
    var img = photo.querySelector(isVideo ? 'video' : 'img');
    if (!img) return;

    var lb = document.createElement('div');
    lb.className = 'ohmy-lightbox';
    lb._sourceRect = rect;
    lb._sourceRot = rot;

    var frame = document.createElement('div');
    frame.className = 'ohmy-lightbox__img';
    frame.style.top = rect.top + 'px';
    frame.style.left = rect.left + 'px';
    frame.style.width = rect.width + 'px';
    frame.style.height = rect.height + 'px';
    frame.style.transform = 'rotate(' + rot + ')';

    var big;
    if (isVideo) {
      // Video klonen: mit Bedienelementen und Ton, läuft direkt weiter
      big = img.cloneNode(true);
      big.controls = true;
      big.muted = false;
      big.autoplay = true;
      big.style.display = 'block';
      big.style.width = '100%';
      big.style.height = '100%';
      big.style.objectFit = 'contain';
    } else {
      big = document.createElement('img');
      big.src = photo.dataset.zoomSrc;
      big.alt = img.alt || '';
    }
    frame.appendChild(big);
    lb.appendChild(frame);
    document.body.appendChild(lb);
    if (isVideo) { big.play && big.play().catch(function () {}); }
    openLightbox = lb;

    // Zielmaße: Bild-/Videoverhältnis einpassen in 90vw × 85vh
    var ratio;
    if (isVideo && img.videoWidth && img.videoHeight) {
      ratio = img.videoWidth / img.videoHeight;
    } else if (img.naturalWidth && img.naturalHeight) {
      ratio = img.naturalWidth / img.naturalHeight;
    } else {
      ratio = rect.width / rect.height;
    }
    var maxW = window.innerWidth * 0.9;
    var maxH = window.innerHeight * 0.85;
    var targetW = Math.min(maxW, maxH * ratio);
    var targetH = targetW / ratio;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        lb.classList.add('is-open');
        frame.style.top = ((window.innerHeight - targetH) / 2) + 'px';
        frame.style.left = ((window.innerWidth - targetW) / 2) + 'px';
        frame.style.width = targetW + 'px';
        frame.style.height = targetH + 'px';
        frame.style.transform = 'rotate(0deg)';
      });
    });

    lb.addEventListener('click', closeLightbox);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  /* ---------- 3) Mehr anzeigen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ohmy-load-more]');
    if (!btn) return;
    var collage = btn.closest('.ohmy-collage');
    if (!collage) return;
    var step = parseInt(btn.dataset.step, 10) || 6;
    var hidden = collage.querySelectorAll('.ohmy-collage__photo--more-hidden');
    for (var i = 0; i < Math.min(step, hidden.length); i++) {
      hidden[i].classList.remove('ohmy-collage__photo--more-hidden');
    }
    if (hidden.length <= step) {
      btn.parentElement.remove(); // alle sichtbar -> Button weg
    }
  });
})();
